// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/commerce/consultation_plans.yaml

export type PremiumReportPlanId =
  | "brihat_kundali"
  | "career_report"
  | "marriage_report"
  | "annual_forecast"
  | "muhurat_report"
  | "dosha_remedy_plan"
  | "sade_sati"
  | "pitra_dosh"
  | "mahadasha_forecast";

export interface PremiumReportPlan {
  id: PremiumReportPlanId;
  name: string;
  name_hi?: string;
  description: string;
  description_hi?: string;
  price_inr: number;
  price_paisa: number;
  pages: number;
  credits_included: number;
  llm_model_override?: string;
  shopify?: {
    handle: string;
    product_id: number;
    variant_id: number;
  };
}

export const premiumReportPlans: readonly PremiumReportPlan[] = [
  {
    id: "brihat_kundali",
    name: "Brihat Kundali Report",
    name_hi: "बृहत् कुंडली रिपोर्ट",
    description:
      "Complete private PDF — personality, career, marriage, health, dasha predictions, yearly forecast, remedies",
    description_hi:
      "संपूर्ण निजी PDF — व्यक्तित्व, जीविका, विवाह, स्वास्थ्य, दशा फल, वार्षिक भविष्यवाणी, उपाय",
    price_inr: 399,
    price_paisa: 39900,
    pages: 51,
    llm_model_override: "claude_premium",
    credits_included: 10,
    shopify: {
      handle: "brihat-kundali-report",
      product_id: 8105748430941,
      variant_id: 44344311414877,
    },
  },
  {
    id: "career_report",
    name: "Career & Finance Report",
    name_hi: "जीविका एवं धन रिपोर्ट",
    description:
      "Comprehensive 24-page report — 10th house & D10 career chart, aptitude & fields, Ashtakavarga/Shadbala strength, full dasha timeline, transits, wealth yogas, best periods, remedies, FAQ",
    price_inr: 199,
    price_paisa: 19900,
    pages: 28,
    credits_included: 5,
    shopify: {
      handle: "career-finance-report",
      product_id: 8105748463709,
      variant_id: 44344311447645,
    },
  },
  {
    id: "marriage_report",
    name: "Marriage & Compatibility Report",
    name_hi: "विवाह एवं अनुकूलता रिपोर्ट",
    description:
      "Detailed marriage timing, spouse characteristics, Mangal Dosha analysis, compatibility insights",
    price_inr: 199,
    price_paisa: 19900,
    pages: 12,
    credits_included: 5,
    shopify: {
      handle: "marriage-compatibility-report",
      product_id: 8105748496477,
      variant_id: 44344311513181,
    },
  },
  {
    id: "annual_forecast",
    name: "Annual Forecast 2026-27",
    name_hi: "वार्षिक भविष्यफल 2026-27",
    description:
      "Month-by-month predictions for the coming year based on transits and dashas — with chart, Ashtakavarga/Shadbala strength, dasha timeline & remedies",
    price_inr: 149,
    price_paisa: 14900,
    pages: 17,
    credits_included: 10,
    shopify: {
      handle: "annual-forecast-2026-27",
      product_id: 8105748529245,
      variant_id: 44344311578717,
    },
  },
  {
    id: "muhurat_report",
    name: "Personal Muhurat & Sankalp Plan",
    name_hi: "व्यक्तिगत मुहूर्त एवं संकल्प योजना",
    description:
      "Purpose-specific timing guidance, avoid windows, sankalp, and ritual checklist — with chart, strength, dasha timeline, transits &amp; remedies",
    price_inr: 149,
    price_paisa: 14900,
    pages: 17,
    credits_included: 5,
  },
  {
    id: "dosha_remedy_plan",
    name: "Dosha Diagnosis & Remedy Plan",
    name_hi: "दोष निदान एवं उपाय योजना",
    description:
      "Chart-specific dosha severity, cancellation checks, safe remedy routine, and matched product guidance",
    price_inr: 199,
    price_paisa: 19900,
    pages: 18,
    credits_included: 10,
  },
  {
    id: "sade_sati",
    name: "Sade Sati Personal Report",
    name_hi: "साढ़े साती व्यक्तिगत रिपोर्ट",
    description:
      "Your natal Saturn, current Sade Sati phase & dates, dasha context, plus chart, strength, transits & remedies",
    price_inr: 149,
    price_paisa: 14900,
    pages: 13,
    credits_included: 5,
  },
  {
    id: "pitra_dosh",
    name: "Pitra Dosh Personal Report",
    name_hi: "पितृ दोष व्यक्तिगत रिपोर्ट",
    description:
      "Engine-verified Pitra Dosh diagnosis, 9th-house ancestral signature, dasha activation window, and chart-specific upay (tarpan, shradh)",
    price_inr: 149,
    price_paisa: 14900,
    pages: 12,
    credits_included: 5,
  },
  {
    id: "mahadasha_forecast",
    name: "12-Month Mahadasha Forecast",
    name_hi: "१२ माह की महादशा भविष्यवाणी",
    description:
      "Current mahadasha/antardasha, the next 12 months of sub-periods, next transition, plus chart, strength, transits & remedies",
    price_inr: 199,
    price_paisa: 19900,
    pages: 16,
    credits_included: 10,
  },
] as const;

export const premiumReportPlanIds: readonly PremiumReportPlanId[] = premiumReportPlans.map(
  (plan) => plan.id
);

export const premiumReportPlanMap: Readonly<Record<PremiumReportPlanId, PremiumReportPlan>> =
  Object.fromEntries(premiumReportPlans.map((plan) => [plan.id, plan])) as Record<
    PremiumReportPlanId,
    PremiumReportPlan
  >;

export function getPremiumReportPlan(planId: string): PremiumReportPlan | null {
  return premiumReportPlanMap[planId as PremiumReportPlanId] ?? null;
}
